const ENABLED = process.env.NODE_ENV === 'development';

export type MapSwitchPerfMeta = {
  mapId?: string;
  blockCount?: number;
  lineCount?: number;
  path?: 'fast' | 'slow' | 'background' | 'cache';
};

let activeSwitchId = 0;

export function beginMapSwitch(meta?: MapSwitchPerfMeta): number {
  if (!ENABLED) return 0;
  activeSwitchId += 1;
  const id = activeSwitchId;
  try {
    performance.mark(`map_switch_start_${id}`);
    if (meta) {
      // eslint-disable-next-line no-console
      console.debug('[mapSwitchPerf] start', { id, ...meta });
    }
  } catch {
    /* ignore */
  }
  return id;
}

export function markMapSwitchPhase(phase: string, switchId?: number): void {
  if (!ENABLED) return;
  const suffix = switchId ? `_${switchId}` : '';
  try {
    performance.mark(`map_switch_${phase}${suffix}`);
  } catch {
    /* ignore */
  }
}

export function endMapSwitch(
  switchId: number,
  phase: string,
  meta?: MapSwitchPerfMeta
): void {
  if (!ENABLED || !switchId) return;
  try {
    const endMark = `map_switch_${phase}_${switchId}`;
    performance.mark(endMark);
    performance.measure(
      `map_switch:${phase}`,
      `map_switch_start_${switchId}`,
      endMark
    );
    const entries = performance.getEntriesByName(`map_switch:${phase}`);
    const last = entries[entries.length - 1];
    if (last) {
      // eslint-disable-next-line no-console
      console.debug('[mapSwitchPerf] end', {
        phase,
        durationMs: Math.round(last.duration),
        ...meta,
      });
    }
  } catch {
    /* ignore */
  }
}
